import {
  analytics,
  getScreenTapExportEvent,
} from '~entities/amplitude-analytics';
import type { FindPaymentsRequestParams } from '~entities/payment';
import { useGenerateReportMutation } from '~entities/payment';
import { isReportGenerated } from '~entities/payment/lib/is-report-generated';
import {
  useCheckReportStatusQuery,
  useDownloadReportQuery,
} from '~entities/report';

import { LoadingButton } from '@platform-ui/button';

import { ReactComponent as DownloadIcon } from './download-icon.svg';

export const PaymentsExport = ({
  params,
  disabled,
}: {
  params: FindPaymentsRequestParams;
  disabled?: boolean;
}) => {
  const generateReportMutation = useGenerateReportMutation();
  const checkStatusQuery = useCheckReportStatusQuery(
    generateReportMutation.data?.reportId
  );
  const downloadQuery = useDownloadReportQuery(
    {
      reportData: checkStatusQuery.data,
      screen: 'payments',
    },
    {
      onSuccess() {
        generateReportMutation.reset();
      },
    }
  );

  const handleExportClick = () => {
    generateReportMutation.mutate(params);
    analytics.track(getScreenTapExportEvent('payments'));
  };
  const reportGenerationInProgress =
    generateReportMutation.isSuccess &&
    !isReportGenerated(checkStatusQuery.data);
  const downloadInProgress =
    isReportGenerated(checkStatusQuery.data) && downloadQuery.isLoading;

  const showLoader =
    generateReportMutation.isLoading ||
    reportGenerationInProgress ||
    downloadInProgress;

  return (
    <div className="min-w-[181px]">
      <LoadingButton
        icon={!showLoader && <DownloadIcon />}
        size="m"
        theme="secondary"
        wide
        loading={showLoader}
        disabled={showLoader || disabled}
        onClick={handleExportClick}
      >
        Export to Excel
      </LoadingButton>
    </div>
  );
};
